var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2349_2355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9103 3.59006L14.9003 7.81006C15.0503 8.12006 15.3303 8.34008 15.6703 8.39008L20.1303 9.07007C20.9603 9.20007 21.3003 10.2701 20.6903 10.8801L17.4603 14.1701C17.2203 14.4101 17.1103 14.77 17.1703 15.11L17.9303 19.7501C18.0703 20.6201 17.2003 21.2801 16.4503 20.8701L12.4603 18.6801C12.1603 18.5201 11.8103 18.5201 11.5103 18.6801L7.52029 20.8701C6.77029 21.2801 5.90031 20.6201 6.04031 19.7501L6.80029 15.11C6.86029 14.77 6.75031 14.4101 6.51031 14.1701L3.2803 10.8801C2.6803 10.2701 3.0103 9.19007 3.8403 9.07007L8.30029 8.39008C8.63029 8.34008 8.92031 8.12006 9.07031 7.81006L11.0603 3.59006C11.4303 2.80006 12.5103 2.80006 12.8803 3.59006H12.9103Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2349_2355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/Star-2.5e4a7292e1dfe1104bf2b95f1a6d7313.svg";
export { ForwardRef as ReactComponent };